import React from "react";

const ReRegisterFormPrescriber = ({
  registerForm,
  isPrescriber,
  isConnectedNurse,
}) => {
  const displayConditionallyName = isPrescriber
    ? "Physician"
    : isConnectedNurse
    ? "Nurse"
    : "Registrar";

  return (
    <React.Fragment>
      <h1 className="select-category-txt-register">
        {isPrescriber
          ? "Prescribing Physician"
          : isConnectedNurse
          ? "Nurse"
          : "Registrar"}{" "}
        Re-Registration Form
      </h1>

      <hr className="green-hr" />

      <div className="group-back">
        <div>
          {isPrescriber
            ? "Prescribing Physician"
            : isConnectedNurse
            ? "Nurse"
            : "Registrar"}{" "}
          Re-Registration Form
        </div>
      </div>
      <div className="wrapper-brackground">
        <h2 className="title-details">{displayConditionallyName} Details</h2>
        <div className="container">
          <div className="row">
            <div className="col">
              <label className="disabled">
                {displayConditionallyName} First Name:
              </label>
              <input
                type="text"
                name="first_name"
                value={registerForm?.first_name}
                disabled
              />
            </div>
            <div className="col">
              <label className="disabled">
                {displayConditionallyName} Last Name:
              </label>
              <input
                type="text"
                name="last_name"
                value={registerForm?.last_name}
                disabled
              />
            </div>
          </div>

          <div className="row">
            <div className="col">
              <label className="disabled">Medical Council Number:</label>
              <input
                type="text"
                name="registration_number"
                value={
                  registerForm?.prescriber?.registration_number ||
                  (registerForm?.connected_nurse?.prescribers &&
                    registerForm?.connected_nurse?.prescribers[0]
                      ?.registration_number)
                }
                disabled
              />
            </div>
            <div className="col">
              <label className="disabled">Job Title:</label>
              <input
                type="text"
                name="phone_number"
                value={
                  registerForm?.prescriber?.job_title ||
                  registerForm?.connected_nurse?.job_title
                }
                disabled
              />
            </div>

            <div className="row">
              <div className="col">
                <label className="disabled">Hospital Name:</label>
                <input
                  type="text"
                  name="phone_number"
                  value={
                    registerForm?.prescriber?.hospital?.name ||
                    (registerForm?.connected_nurse?.prescribers[0] &&
                      registerForm?.connected_nurse?.prescribers[0]?.hospital
                        ?.name)
                  }
                  disabled
                />
              </div>

              <div className="col"></div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <label className="disabled">Hospital Address:</label>
              <input
                type="text"
                name="hospital_address"
                value={
                  registerForm?.prescriber?.hospital?.address?.full_address ||
                  (registerForm?.connected_nurse?.prescribers &&
                    registerForm?.connected_nurse?.prescribers[0]?.hospital
                      ?.address?.full_address)
                }
                disabled
              />
            </div>
          </div>
        </div>

        <h2 className="title-details">Account Details</h2>

        <div className="container">
          <div className="row">
            <div className="col">
              <label className="disabled">Email Address:</label>
              <input
                type="text"
                name="email"
                value={registerForm?.email}
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ReRegisterFormPrescriber;
